/** Pendant zu `RedirectToLogin.razor` und dem `NotAuthorized`-Zweig der `AuthorizeRouteView`. */

import type { ReactElement, ReactNode } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { LoadingIndicator } from '@/components/layout/LoadingIndicator';

import { getAuthenticatedAccount } from './msalInstance';
import { useAuth } from './useAuth';

export function RequireAuth({ children }: { children: ReactNode }): ReactElement {
  const { authorized, initializing } = useAuth();
  const navigate = useNavigate();
  const accountId = getAuthenticatedAccount()?.homeAccountId ?? null;

  useEffect(() => {
    if (initializing || accountId !== null) {
      return;
    }
    void navigate(`/authentication/login?returnUrl=${encodeURIComponent(window.location.href)}`);
  }, [accountId, initializing, navigate]);

  if (initializing) {
    return <LoadingIndicator />;
  }

  if (accountId === null) {
    return <></>;
  }

  if (!authorized) {
    return <p role="alert">You are not authorized to access this resource.</p>;
  }

  return <>{children}</>;
}

export default RequireAuth;
